module.exports = __webpack_public_path__ + "static/media/hair-4.189d44f0.svg";